"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreWebSocket = exports.WEB_SOCKET_URL = void 0;
exports.WEB_SOCKET_URL = 'wss://store-ws.xsolla.com/sub/order/status';
var StoreWebSocket = /** @class */ (function () {
    function StoreWebSocket(userInfo, disableHistoryOnConnect) {
        if (disableHistoryOnConnect === void 0) { disableHistoryOnConnect = false; }
        this.disableHistoryOnConnect = false;
        this._onclose = null;
        this._onerror = null;
        this._onmessage = null;
        this._onopen = null;
        this.url = exports.WEB_SOCKET_URL + '?user_external_id=' + userInfo.user_external_id;
        this.disableHistoryOnConnect = disableHistoryOnConnect;
    }
    Object.defineProperty(StoreWebSocket.prototype, "onclose", {
        get: function () {
            return this._onclose;
        },
        set: function (handler) {
            this._onclose = handler;
            this.client && (this.client.onclose = this._onclose);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreWebSocket.prototype, "onerror", {
        get: function () {
            return this._onerror;
        },
        set: function (handler) {
            this._onerror = handler;
            this.client && (this.client.onerror = this._onerror);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreWebSocket.prototype, "onmessage", {
        get: function () {
            return this._onmessage;
        },
        set: function (handler) {
            this._onmessage = function (event) { return handler && handler(JSON.parse(event.data)); };
            this.client && (this.client.onmessage = this._onmessage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreWebSocket.prototype, "onopen", {
        get: function () {
            return this._onopen;
        },
        set: function (handler) {
            this._onopen = handler;
            this.client && (this.client.onopen = this._onopen);
        },
        enumerable: false,
        configurable: true
    });
    StoreWebSocket.prototype.connect = function () {
        this.client = new WebSocket(this.url);
        this.client.onopen = this._onopen;
        this.client.onmessage = this._onmessage;
        this.client.onerror = this._onerror;
        this.client.onclose = this._onclose;
    };
    StoreWebSocket.prototype.close = function () {
        this.client.close();
    };
    return StoreWebSocket;
}());
exports.StoreWebSocket = StoreWebSocket;
//# sourceMappingURL=store-websocket.js.map